import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TabService {
  tabclose$: Subject<any> = new Subject();
  tabInserted$: Subject<any> = new Subject();
  tabCloseEvent$: Subject<boolean> = new Subject();
  tabUnsavedDataEvent$: Subject<any> = new Subject();
  tabTitleChangedEvent$: Subject<any> = new Subject();
  tabClosed(tab) {
    this.tabclose$.next(tab);
  }
  getTabcloseEvent() {
    return this.tabclose$;
  }
  tabInsertedEvent(dynamicTabs){
    this.tabInserted$.next(dynamicTabs)
  }
  getTabInserted(){
    return this.tabInserted$;
  }
  unsavedDataEventForTab(tab){
    this.tabUnsavedDataEvent$.next(tab)
  }
  tabTitleChange(data){
    this.tabTitleChangedEvent$.next(data);
  }
}
